<template>
    <div class="book-a-showing">
        <div class="book-a-showing__top closed" @click="toggleDropdown($event)">
            <div class="form-container">
                <p class="subtitle text-primary">{{ $t('components.schedule_showing.title') }}</p>
                <p class="button-text text-primary-blue ml-auto mr-20">{{ $t('listing_form.remaining_details.expand') }}</p>
                <img class="schedule__toggle" src="/img/arrows/arrow-up-primary.svg" alt="">
                <help-popup :title="$t('listing_form.help_popup.schedule_showing')" :description="$t('listing_form.help_popup.schedule_showing_description')" image="/img/help-preview/schedule-showing.png"></help-popup>
            </div>
        </div>
        <div class="book-a-showing__body">
            <div class="book-a-showing__body__content">
                <div class="schedule-content">      
                    <div class="schedule-content__days">
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[1]" class="text-primary">{{ $t('components.schedule_showing.monday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[2]" class="text-primary">{{ $t('components.schedule_showing.tuesday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[3]" class="text-primary">{{ $t('components.schedule_showing.wednesday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[4]" class="text-primary">{{ $t('components.schedule_showing.thursday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[5]" class="text-primary">{{ $t('components.schedule_showing.friday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[6]" class="text-primary">{{ $t('components.schedule_showing.saturday') }}</a-checkbox>
                        </div>
                        <div class="schedule-content__checkbox-wrap">
                            <a-checkbox v-model="schedule.days[7]" class="text-primary">{{ $t('components.schedule_showing.sunday') }}</a-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            listing_id: Number,
            schedule_showing: Object
        },
        created() {
            if (this.schedule_showing) {
                this.schedule = this.schedule_showing;
            }
        },
        data() {
            return {
                schedule: {
                    days: {
                        1: false,
                        2: false,
                        3: false,
                        4: false,
                        5: false,
                        6: false,
                        7: false,
                    }
                },
                updated: false
            }
        },
        mounted() {
        },
        methods: {
            saveData() {
                const url = `/api/listing/agent-details/${this.listing_id}/schedule`;

                return axios.post(url, {
                    schedule_showing: this.schedule
                }).then(function (response) {
                }.bind(this))
                .catch(error => {
                    this.$toastr.error('error');
                })
            },
            toggleDropdown(e) {
                let panel = e.target.nextElementSibling;

                if (e.target.classList.contains('open')) {
                    e.target.classList.add('closed')
                    e.target.classList.remove('open');
                } else {
                    e.target.classList.toggle('closed')
                    e.target.classList.add('open')
                }

                if (panel.style.maxHeight) {
                    panel.style.maxHeight = null;
                } else {
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            },
        },
        watch: {
            schedule: {
                immediate: false,
                handler: _.debounce(function () {
                    if (this.updated) {
                        this.saveData();
                    }
                }, 1000),
                deep: true
            },
        },
        updated() {
            this.updated = true;
        }

    }
</script>